import * as Utils from '@ext/index';
import { Pedido } from '@/__env/lib/Ventas/Pedidos/Pedido.nav';
import * as Envios from '@/__env/lib/Ventas/Envios';



export class Estados {

    constructor ( id: string, descripcion: string ) {
        this.Id = id;
        this.Descripcion = descripcion;
    }

    public readonly Id: string;
    public readonly Descripcion: string;

    public static toTipo ( id: string ): Estados {

        if ( id === this.Creado.Id )
            return this.Creado;
        else if ( id === this.Descargado.Id )
            return this.Descargado;
        else if ( id === this.EsperandoAutorizacion.Id )
            return this.EsperandoAutorizacion;
        else if ( id === this.Pendiente.Id )
            return this.Pendiente;
        else if ( id === this.NoAutorizado.Id )
            return this.NoAutorizado;
        else if ( id === this.Autorizado.Id )
            return this.Autorizado;
        else if ( id === this.Preparando.Id )
            return this.Preparando;
        else if ( id === this.Facturado.Id )
            return this.Facturado;
        else if ( id === this.ListoParaDespachar.Id )
            return this.ListoParaDespachar;
        else if ( id === this.ListoParaRetirar.Id )
            return this.ListoParaRetirar;
        else if ( id === this.Despachado.Id )
            return this.Despachado;
        else if ( id === this.Entregado.Id )
            return this.Entregado;
        else if ( id === this.NoEntregado.Id )
            return this.NoEntregado;
        else if ( id === this.Devuelto.Id )
            return this.Devuelto;
        else if ( id === this.Cancelado.Id )
            return this.Cancelado;
        else if ( id === this.ProcesadoFueraDeSistema.Id )
            return this.ProcesadoFueraDeSistema;


        return new Estados( id, id );
    }

    public static readonly Creado: Estados = new Estados( 'creado', 'Pendiente' );
    public static readonly Descargado: Estados = new Estados( 'descargado', 'Descargado' );
    public static readonly EsperandoAutorizacion: Estados = new Estados( 'esperando-autorizacion', 'Pendiente' );
    public static readonly Pendiente: Estados = new Estados( 'pendiente', 'Pendiente' );
    public static readonly NoAutorizado: Estados = new Estados( 'no-autorizado', 'No autorizado' );
    public static readonly Autorizado: Estados = new Estados( 'autorizado', 'Autorizado' );
    public static readonly Preparando: Estados = new Estados( 'en-proceso', 'Preparando' );
    public static readonly Facturado: Estados = new Estados( 'facturado', 'Facturado' );
    public static readonly ListoParaDespachar: Estados = new Estados( 'listo-para-despachar', 'Listo para depachar' );
    public static readonly ListoParaRetirar: Estados = new Estados( 'listo-para-retirar', 'Listo para retirar' );
    public static readonly Despachado: Estados = new Estados( 'despachado', 'Despachado' );
    public static readonly Entregado: Estados = new Estados( 'entregado', 'Entregado' );
    public static readonly NoEntregado: Estados = new Estados( 'no-entregado', 'No entregado' );
    public static readonly Devuelto: Estados = new Estados( 'devuelto', 'Devuelto' );
    public static readonly Cancelado: Estados = new Estados( 'cancelado', 'Cancelado' );
    public static readonly ProcesadoFueraDeSistema: Estados = new Estados( 'fuera-de-sistema', 'Fuera de sistema' );

    public static Options: Array<Estados> = [
        Estados.Creado,
        Estados.Descargado,
        Estados.EsperandoAutorizacion,
        Estados.NoAutorizado,
        Estados.Autorizado,
        Estados.Preparando,
        Estados.Facturado,
        Estados.ListoParaDespachar,
        Estados.ListoParaRetirar,
        Estados.Despachado,
        Estados.Entregado,
        Estados.NoEntregado,
        Estados.Devuelto,
        Estados.Cancelado,
        Estados.ProcesadoFueraDeSistema,
    ];

    public static Filter = [
        { Id: 0, Nombre: 'Todos', Valor: [] },
        { Id: 1, Nombre: 'Pendientes', Valor: [Estados.EsperandoAutorizacion, Estados.Creado] },
        { Id: 2, Nombre: 'Preparando', Valor: [Estados.Autorizado, Estados.Preparando] },
        { Id: 3, Nombre: 'Despachados', Valor: [Estados.Despachado] },
        { Id: 4, Nombre: 'Entregados', Valor: [Estados.Entregado] },
        { Id: 5, Nombre: 'No autorizados', Valor: [Estados.NoAutorizado] },
        { Id: 6, Nombre: 'Cancelados', Valor: [Estados.Cancelado] },
    ];

    public get esCreado (): boolean { return this.Id === Estados.Creado.Id; }
    public get esPendiente (): boolean { return this.Id === Estados.Pendiente.Id; }
    public get esDescargado (): boolean { return this.Id === Estados.Descargado.Id; }
    public get esEsperandoAutorizacion (): boolean { return this.Id === Estados.EsperandoAutorizacion.Id; }
    public get esNoAutorizado (): boolean { return this.Id === Estados.NoAutorizado.Id; }
    public get esAutorizado (): boolean { return this.Id === Estados.Autorizado.Id; }
    public get esPreparando (): boolean { return this.Id === Estados.Preparando.Id; }
    public get esFacturado (): boolean { return this.Id === Estados.Facturado.Id; }
    public get esListoParaDespachar (): boolean { return this.Id === Estados.ListoParaDespachar.Id; }
    public get esListoParaRetirar (): boolean { return this.Id === Estados.ListoParaRetirar.Id; }
    public get esDespachado (): boolean { return this.Id === Estados.Despachado.Id; }
    public get esEntregado (): boolean { return this.Id === Estados.Entregado.Id; }
    public get esNoEntregado (): boolean { return this.Id === Estados.NoEntregado.Id; }
    public get esDevuelto (): boolean { return this.Id === Estados.Devuelto.Id; }
    public get esCancelado (): boolean { return this.Id === Estados.Cancelado.Id; }


    public get Mensaje (): { Mensaje: string, Auto: boolean; } {

        if ( this.esCreado ) return { Mensaje: '', Auto: true };
        else if ( this.esDescargado ) return { Mensaje: '', Auto: true };
        else if ( this.esEsperandoAutorizacion ) return { Mensaje: '', Auto: true };
        else if ( this.esNoAutorizado ) return { Mensaje: 'No autorizar', Auto: false };
        else if ( this.esAutorizado ) return { Mensaje: 'Autorizar', Auto: false };
        else if ( this.esPreparando ) return { Mensaje: '', Auto: true };
        else if ( this.esFacturado ) return { Mensaje: 'Facturado', Auto: false };
        else if ( this.esListoParaRetirar ) return { Mensaje: '', Auto: true };
        else if ( this.esListoParaDespachar ) return { Mensaje: '', Auto: true };
        else if ( this.esDespachado ) return { Mensaje: 'Despachado', Auto: false };
        else if ( this.esEntregado ) return { Mensaje: 'Entregado', Auto: false };
        else if ( this.esNoEntregado ) return { Mensaje: 'No entregado', Auto: false };
        else if ( this.esDevuelto ) return { Mensaje: 'Devuelto', Auto: false };
        else if ( this.esCancelado ) return { Mensaje: 'Cancelar', Auto: false };

        return { Mensaje: '', Auto: true };
    }
    public get Inicial (): boolean {

        return this.Id === Estados.EsperandoAutorizacion.Id ||
            this.Id === Estados.Creado.Id ||
            this.Id === Estados.Descargado.Id ||
            this.Id === Estados.Autorizado.Id;
    }
}

export class Tipos {

    constructor ( id: string, descripcion: string, lista: string, precio: string, clientePredeterminado: number, vendedorPredeterminado: number, tipoEnvioPredeterminado: Envios.Tipos ) {
        this.Id = id;
        this.Descripcion = descripcion;
        this.Lista = lista;
        this.Precio = precio;
        this.ClientePredeterminado = clientePredeterminado;
        this.VendedorPredeterminado = vendedorPredeterminado;
        this.TipoEnvioPredeterminado = tipoEnvioPredeterminado;
    }

    public readonly Id: string;
    public readonly Descripcion: string;
    public readonly Lista: string;
    public readonly Precio: string;
    public readonly ClientePredeterminado: number;
    public readonly VendedorPredeterminado: number;
    public readonly TipoEnvioPredeterminado: Envios.Tipos;

    public static toTipo ( id: string ): Tipos {

        for ( let tipo of Tipos.Options ) {
            if ( id === tipo.Id )
                return tipo;
        }

        if ( id == Tipos.NoEspecificado.Id ) return Tipos.NoEspecificado;

        return Tipos.NoEspecificado;
    }

    public static readonly TiendaIntex: Tipos = new Tipos( 'tienda-intex', 'Web Intex (Necxus)', 'minorista', 'final', 0, 562, Envios.Tipos.NoEspecificado );
    public static readonly MercadoLibre: Tipos = new Tipos( 'mercado-libre', 'MercadoLibre', 'minorista', 'final', 0, 0, Envios.Tipos.NoEspecificado );

    public static readonly IntexWeb: Tipos = new Tipos( 'intex_web', 'Intex WEB', 'intex_web', 'final', 0, 500, Envios.Tipos.Plataforma );
    public static readonly DrLineablancaWeb: Tipos = new Tipos( 'drlineablanca_web', 'DrLineablanca WEB', 'drlineablanca_web', 'final', 0, 500, Envios.Tipos.Plataforma );
    public static readonly YPF: Tipos = new Tipos( 'ypf_serviclub', 'YPF SERVICLUB', 'ypf_serviclub', 'final', 0, 562, Envios.Tipos.Plataforma );
    public static readonly Linio: Tipos = new Tipos( 'linio', 'Linio', 'linio', 'final', 0, 561, Envios.Tipos.Plataforma );
    public static readonly Falabella: Tipos = new Tipos( 'falabella', 'Falabella', 'falabella', 'final', 40007, 561, Envios.Tipos.Plataforma );
    public static readonly Fravega: Tipos = new Tipos( 'fravega', 'Fravega', 'fravega', 'final', 0, 561, Envios.Tipos.Plataforma );
    public static readonly Cetrogar: Tipos = new Tipos( 'cetrogar', 'Cetrogar', 'cetrogar', 'final', 0, 500, Envios.Tipos.Plataforma );
    public static readonly Garbarino: Tipos = new Tipos( 'garbarino', 'Garbarino', 'garbarino', 'final', 0, 561, Envios.Tipos.Plataforma );
    public static readonly Necxus: Tipos = new Tipos( 'necxus', 'Necxus', 'necxus', 'final', 0, 562, Envios.Tipos.Plataforma );
    public static readonly Sodimac: Tipos = new Tipos( 'sodimac', 'Sodimac', 'sodimac', 'final', 40011, 561, Envios.Tipos.Plataforma );
    public static readonly ProvinciaCompras: Tipos = new Tipos( 'provincia-compras', 'ProvinciaCompras', 'provincia-compras', 'final', 0, 500, Envios.Tipos.Plataforma );
    public static readonly AvCompras: Tipos = new Tipos( 'av_compras', 'Avenida Compras', 'av_compras', 'final', 0, 561, Envios.Tipos.Plataforma );
    public static readonly Musimundo: Tipos = new Tipos( 'musimundo', 'Musimundo', 'musimundo', 'final', 0, 561, Envios.Tipos.Plataforma );
    public static readonly CasaAudio: Tipos = new Tipos( 'casaaudio', 'Casa del Audio', 'casaaudio', 'final', 40028, 561, Envios.Tipos.Plataforma );

    public static readonly Agrupate: Tipos = new Tipos( 'agrupate', 'Agrupate', 'agrupate', 'final', 0, 561, Envios.Tipos.Plataforma );
    public static readonly CorreoCompras: Tipos = new Tipos( 'correo_compras', 'Correo Compras', 'correo_compras', 'final', 0, 561, Envios.Tipos.Plataforma );
    public static readonly FamiliaBercomat: Tipos = new Tipos( 'familia_bercomat', 'Familia Bercomat', 'familia_bercomat', 'final', 0, 561, Envios.Tipos.Plataforma );
    public static readonly GoShop: Tipos = new Tipos( 'go_shop', 'GoShop', 'go_shop', 'final', 0, 561, Envios.Tipos.Plataforma );
    public static readonly IcbcMall: Tipos = new Tipos( 'icbc_mall', 'IcbcMall', 'icbc_mall', 'final', 0, 561, Envios.Tipos.Plataforma );
    public static readonly Smiles: Tipos = new Tipos( 'smiles', 'Smiles', 'smiles', 'final', 0, 561, Envios.Tipos.Plataforma );
    public static readonly TiendaCiudad: Tipos = new Tipos( 'tienda_ciudad', 'Tienda Ciudad', 'tienda_ciudad', 'final', 0, 561, Envios.Tipos.Plataforma );
    public static readonly TiendaClic: Tipos = new Tipos( 'tienda_clic', 'Tienda Clic', 'tienda_clic', 'final', 0, 561, Envios.Tipos.Plataforma );
    public static readonly TiendaNacion: Tipos = new Tipos( 'tienda_nacion', 'Tienda Nacion', 'tienda_nacion', 'final', 0, 561, Envios.Tipos.Plataforma );
    public static readonly TiendaNaranja: Tipos = new Tipos( 'tienda_naranja', 'Tienda Naranja', 'tienda_naranja', 'final', 0, 561, Envios.Tipos.Plataforma );
    public static readonly TiendaSupervielle: Tipos = new Tipos( 'tienda_supervielle', 'Tienda Supervielle', 'tienda_supervielle', 'final', 0, 561, Envios.Tipos.Plataforma );

    public static readonly Mostrador: Tipos = new Tipos( 'mostrador', 'Mostrador', 'minorista', 'final', 0, 0, Envios.Tipos.RetiraCliente );
    public static readonly Normal: Tipos = new Tipos( 'normal', 'Normal', 'mayorista', 'neto', 0, 0, Envios.Tipos.CuentaCorriente );
    public static readonly NoEspecificado: Tipos = new Tipos( 'no-especificado', 'No especificado', 'mayorista', 'neto', 0, 0, Envios.Tipos.NoEspecificado );

    public static Options: Array<Tipos> = [
        Tipos.IntexWeb,
        Tipos.DrLineablancaWeb,
        Tipos.YPF,
        Tipos.TiendaIntex,
        Tipos.MercadoLibre,
        Tipos.Necxus,
        Tipos.Linio,
        Tipos.Falabella,
        Tipos.Fravega,
        Tipos.Cetrogar,
        Tipos.Garbarino,
        Tipos.Necxus,
        Tipos.Sodimac,
        Tipos.AvCompras,
        Tipos.ProvinciaCompras,
        Tipos.Musimundo,
        Tipos.CasaAudio,

        Tipos.Agrupate,
        Tipos.CorreoCompras,
        Tipos.FamiliaBercomat,
        Tipos.GoShop,
        Tipos.IcbcMall,
        Tipos.Smiles,
        Tipos.TiendaCiudad,
        Tipos.TiendaClic,
        Tipos.TiendaNacion,
        Tipos.TiendaNaranja,
        Tipos.TiendaSupervielle,

        Tipos.Mostrador,
        Tipos.Normal,
    ];

    public static Plataformas: Array<Tipos> = [
        Tipos.IntexWeb,
        Tipos.DrLineablancaWeb,
        Tipos.YPF,
        Tipos.Linio,
        Tipos.Falabella,
        Tipos.ProvinciaCompras,
        Tipos.Fravega,
        Tipos.Cetrogar,
        Tipos.Garbarino,
        Tipos.Necxus,
        Tipos.Sodimac,
        Tipos.AvCompras,
        Tipos.Agrupate,
        Tipos.CorreoCompras,
        Tipos.FamiliaBercomat,
        Tipos.GoShop,
        Tipos.IcbcMall,
        Tipos.Smiles,
        Tipos.TiendaCiudad,
        Tipos.TiendaClic,
        Tipos.TiendaNacion,
        Tipos.TiendaNaranja,
        Tipos.TiendaSupervielle,
        Tipos.Musimundo,
        Tipos.CasaAudio,
    ];

    public static Filter = [
        { Id: 1, Nombre: 'Todos', Valor: [] },
        { Id: 2, Nombre: 'MercadoLibre', Valor: [Tipos.MercadoLibre] },
        { Id: 3, Nombre: 'Web Intex (Necxus)', Valor: [Tipos.TiendaIntex] },
        { Id: 4, Nombre: 'Web', Valor: [Tipos.IntexWeb, Tipos.DrLineablancaWeb] },
        { Id: 5, Nombre: 'Necxus', Valor: [Tipos.Necxus] },
        { Id: 6, Nombre: 'Plataformas', Valor: [...Tipos.Plataformas] },
        { Id: 7, Nombre: Tipos.Garbarino.Descripcion, Valor: [Tipos.Garbarino] },
        { Id: 8, Nombre: Tipos.Linio.Descripcion, Valor: [Tipos.Linio] },
        { Id: 9, Nombre: Tipos.Falabella.Descripcion, Valor: [Tipos.Falabella] },
        { Id: 10, Nombre: Tipos.Fravega.Descripcion, Valor: [Tipos.Fravega] },

        { Id: 11, Nombre: 'Mostrador', Valor: [Tipos.Mostrador] },
        { Id: 12, Nombre: 'Normal', Valor: [Tipos.Normal] },

        { Id: 13, Nombre: Tipos.CorreoCompras.Descripcion, Valor: [Tipos.CorreoCompras] },
        { Id: 14, Nombre: Tipos.FamiliaBercomat.Descripcion, Valor: [Tipos.FamiliaBercomat] },
        { Id: 15, Nombre: Tipos.GoShop.Descripcion, Valor: [Tipos.GoShop] },
        { Id: 16, Nombre: Tipos.IcbcMall.Descripcion, Valor: [Tipos.IcbcMall] },
        { Id: 17, Nombre: Tipos.Smiles.Descripcion, Valor: [Tipos.Smiles] },
        { Id: 18, Nombre: Tipos.TiendaCiudad.Descripcion, Valor: [Tipos.TiendaCiudad] },
        { Id: 19, Nombre: Tipos.TiendaClic.Descripcion, Valor: [Tipos.TiendaClic] },
        { Id: 10, Nombre: Tipos.TiendaNacion.Descripcion, Valor: [Tipos.TiendaNacion] },
        { Id: 21, Nombre: Tipos.TiendaNaranja.Descripcion, Valor: [Tipos.TiendaNaranja] },
        { Id: 22, Nombre: Tipos.TiendaSupervielle.Descripcion, Valor: [Tipos.TiendaSupervielle] },
        { Id: 23, Nombre: Tipos.Agrupate.Descripcion, Valor: [Tipos.Agrupate] },
        { Id: 24, Nombre: Tipos.AvCompras.Descripcion, Valor: [Tipos.AvCompras] },
        { Id: 25, Nombre: Tipos.ProvinciaCompras.Descripcion, Valor: [Tipos.ProvinciaCompras] },
        { Id: 26, Nombre: Tipos.Musimundo.Descripcion, Valor: [Tipos.Musimundo] },
        { Id: 27, Nombre: Tipos.CasaAudio.Descripcion, Valor: [Tipos.CasaAudio] },
        { Id: 28, Nombre: Tipos.Cetrogar.Descripcion, Valor: [Tipos.Cetrogar] },
    ];

    public get Imagen (): string {
        if ( this.esMercadoLibre )
            return Utils.settings.URL.static + "mercadolibre.png";
        else if ( this.esTiendaIntex )
            return Utils.settings.URL.static + "intex.png";
        else
            return '';
    }

    public get ImagenChica (): string {
        if ( this.esMercadoLibre )
            return Utils.settings.URL.static + "mla_chico.png";
        else if ( this.esTiendaIntex )
            return Utils.settings.URL.static + "intex.png";
        else
            return '';
    }

    public get DescripcionExtendida (): string {
        return '';
    }

    public get esNecxus (): boolean { return this.Id === Tipos.Necxus.Id; }
    public get esTiendaIntex (): boolean { return this.Id === Tipos.TiendaIntex.Id; }
    public get esGarbarino (): boolean { return this.Id === Tipos.Garbarino.Id; }
    public get esProvinciaCompras (): boolean { return this.Id === Tipos.ProvinciaCompras.Id; }

    public get esMercadoLibre (): boolean {
        return this.Id === Tipos.MercadoLibre.Id;
    }

    public get esMostrador (): boolean { return this.Id === Tipos.Mostrador.Id; }
    public get esNormal (): boolean { return this.Id === Tipos.Normal.Id; }
    public get esNoEspecificado (): boolean { return this.Id === Tipos.NoEspecificado.Id; }
    public get esPlataforma (): boolean { return Tipos.Plataformas.map( x => x.Id ).includes( this.Id ); }
}